var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGenerateSales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 210,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "generate_sales_svg__a",
    x: 8.882,
    y: 40,
    width: 137,
    height: 101,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "generate_sales_svg__c",
    d: "M0 0h58v59H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#7D32FF",
    cx: 87.719,
    cy: 103,
    rx: 69.754,
    ry: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83 112.978l-4.183 4.624c-2.893 3.197-7.584 3.197-10.477 0-2.893-3.198-2.893-8.383 0-11.58l4.184-4.623c2.892-3.199 7.582-3.199 10.476 0 2.893 3.197 2.893 8.382 0 11.579zm90.994-53.83l-54.112 58.5c-2.902 3.136-7.606 3.136-10.507 0-2.902-3.137-2.902-8.223-.001-11.36l10.032-10.846c2.901-3.136 2.901-8.222 0-11.358-2.9-3.137-7.605-3.137-10.507 0l-10.036 10.85c-2.902 3.131-7.602 3.13-10.502-.005-2.9-3.135-2.902-8.216-.006-11.353l2.198-2.376c2.901-3.136 2.901-8.222 0-11.359-2.902-3.137-7.606-3.137-10.508 0l-2.201 2.38c-2.902 3.127-7.6 3.124-10.498-.01-2.901-3.136-2.901-8.223 0-11.359l54.112-58.5c2.901-3.136 7.606-3.136 10.508 0 2.898 3.133 2.9 8.212.008 11.35L119.51 28.074c-2.903 3.137-2.903 8.223 0 11.359 2.9 3.137 7.604 3.137 10.506 0l13.29-14.37c2.904-3.13 7.603-3.128 10.504.007 2.9 3.135 2.902 8.216.003 11.354l-5.45 5.892c-2.9 3.137-2.9 8.223 0 11.36 2.901 3.136 7.606 3.136 10.508 0l5.446-5.89c2.901-3.135 7.606-3.135 10.507.002 2.901 3.137 2.901 8.222 0 11.36zm11.979-25.805c2.93 3.124 2.93 8.19 0 11.314-2.928 3.124-7.677 3.124-10.606 0-2.93-3.124-2.93-8.19 0-11.314 2.929-3.124 7.678-3.124 10.606 0z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.83 202.978l-4.183 4.624c-2.893 3.197-7.584 3.197-10.477 0-2.893-3.198-2.893-8.383 0-11.58l4.184-4.623c2.892-3.199 7.582-3.199 10.476 0 2.893 3.197 2.893 8.382 0 11.579zm90.994-53.83l-54.112 58.5c-2.902 3.136-7.606 3.136-10.507 0-2.902-3.137-2.902-8.223-.001-11.36l10.032-10.846c2.901-3.136 2.901-8.222 0-11.358-2.9-3.137-7.605-3.137-10.507 0l-10.036 10.85c-2.902 3.131-7.602 3.13-10.502-.005-2.9-3.135-2.902-8.216-.006-11.353l2.198-2.376c2.901-3.136 2.901-8.222 0-11.359-2.902-3.137-7.606-3.137-10.508 0l-2.201 2.38c-2.902 3.127-7.6 3.124-10.498-.01-2.901-3.136-2.901-8.223 0-11.359l54.112-58.5c2.901-3.136 7.606-3.136 10.508 0 2.898 3.133 2.9 8.212.008 11.35L53.51 118.074c-2.903 3.137-2.903 8.223 0 11.359 2.9 3.137 7.604 3.137 10.506 0l13.29-14.37c2.904-3.13 7.603-3.128 10.504.007 2.9 3.135 2.902 8.216.003 11.354l-5.45 5.892c-2.9 3.137-2.9 8.223 0 11.36 2.901 3.136 7.606 3.136 10.508 0l5.446-5.89c2.901-3.135 7.606-3.135 10.507.002 2.901 3.137 2.901 8.222 0 11.36zm11.979-25.805c2.93 3.124 2.93 8.19 0 11.314-2.928 3.124-7.677 3.124-10.606 0-2.93-3.124-2.93-8.19 0-11.314 2.929-3.124 7.678-3.124 10.606 0z",
    fill: "#FFE436"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.118 11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.323 37H145.58a3 3 0 013 3v102.412H5.323V40a3 3 0 013-3z",
    stroke: "#410087",
    fill: "#410087"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#410087",
    fill: "#410087",
    y: 142.412,
    width: 154,
    height: 6.588,
    rx: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "generate_sales_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#generate_sales_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#generate_sales_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    mask: "url(#generate_sales_svg__b)",
    d: "M8.882 40h150v6h-150z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF9582",
    mask: "url(#generate_sales_svg__b)",
    cx: 13.882,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE436",
    mask: "url(#generate_sales_svg__b)",
    cx: 18.882,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BBB4E",
    mask: "url(#generate_sales_svg__b)",
    cx: 23.882,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#generate_sales_svg__b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#410087",
    xlinkHref: "#generate_sales_svg__c",
    transform: "translate(23.882 65)"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#7D32FF",
    x: 90.882,
    y: 110,
    width: 35,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 90.882,
    y: 84,
    width: 45,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 90.882,
    y: 88,
    width: 45,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 90.882,
    y: 98,
    width: 45,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 90.882,
    y: 94,
    width: 45,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 90.882,
    y: 102,
    width: 33,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#878787",
    x: 90.882,
    y: 71,
    width: 26,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#878787",
    x: 90.882,
    y: 76,
    width: 20,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#878787",
    x: 90.882,
    y: 66,
    width: 20,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.882 71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13 24.002c5.63.473 9.179.187 10.65-.856 2.205-1.565 2.74-4.647 1.197-6.882a4.833 4.833 0 00-6.79-1.214c-1.47 1.044-3.156 4.028-5.058 8.952zM22.993 14.656c2.399-1.24 3.352-4.215 2.13-6.647-.815-1.62-3.331-3.402-7.55-5.344-1.573 4.933-1.952 8.21-1.137 9.831 1.222 2.432 4.158 3.399 6.557 2.16zM12.16 10.306c1.199-.62 1.676-2.108 1.064-3.324-.407-.81-1.665-1.7-3.774-2.672-.787 2.467-.977 4.105-.57 4.916a2.422 2.422 0 003.28 1.08zM20.084 18.016c-1.333.19-2.261 1.439-2.074 2.79.125.901 1.028 2.158 2.71 3.772 1.537-2.072 2.242-3.559 2.117-4.46-.187-1.35-1.42-2.292-2.753-2.102zM29.045 9.826a2.427 2.427 0 003.174 1.365c.832-.34 1.817-1.533 2.955-3.579-2.356-1.009-3.95-1.343-4.782-1.002-1.248.51-1.85 1.95-1.347 3.216zM25.472 22.253c.977 1.526 4.163 3.139 9.558 4.838.056-5.288-.404-8.695-1.381-10.22-1.467-2.29-4.486-2.94-6.744-1.453-2.258 1.486-2.9 4.546-1.433 6.835z",
    fill: "#2BBB4E"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 13,
    y: 27.496,
    width: 15.167,
    height: 16.472,
    rx: 2
  }))), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Barlow-Bold, Barlow",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#7D32FF",
    fillOpacity: 0.83
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 134,
    y: 89
  }, "\xA3")), /*#__PURE__*/React.createElement("rect", {
    fill: "#13D0BC",
    x: 69,
    y: 151,
    width: 46,
    height: 46,
    rx: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.544 183c.304 0 .456-.152.456-.456v-2.335c0-.304-.152-.456-.456-.456H90.15c-.071 0-.111-.018-.12-.054-.01-.036.004-.08.04-.134.644-.68.965-1.52.965-2.523v-1.583c0-.107.054-.161.161-.161h4.72c.305 0 .457-.152.457-.456v-2.147c0-.304-.152-.456-.456-.456h-4.72c-.108 0-.162-.054-.162-.161v-2.308c0-.859.206-1.494.617-1.906.412-.411.975-.617 1.69-.617.483 0 .894.116 1.234.349.34.233.617.626.831 1.18.09.216.233.323.43.323.035.018.062.022.08.013a.119.119 0 01.053-.013l2.629-.483c.232-.054.348-.17.348-.35a.595.595 0 00-.026-.187c-.43-1.288-1.118-2.29-2.066-3.006-.947-.715-2.136-1.073-3.567-1.073-1.841 0-3.307.514-4.398 1.543-1.09 1.029-1.636 2.465-1.636 4.307v2.228c0 .107-.054.16-.161.16h-1.636c-.304 0-.456.153-.456.457v2.147c0 .304.152.456.456.456h1.636c.107 0 .16.054.16.161v1.583c0 .573-.084 1.065-.254 1.476-.17.412-.451.76-.845 1.047-.196.143-.295.322-.295.537v2.442c0 .304.152.456.456.456h12.23z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

export default __webpack_public_path__ + "static/generate_sales.bb8a388a.svg";
export { SvgGenerateSales as ReactComponent };